"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialOnDevice = exports.CredentialOnDevicePreference = void 0;
var CredentialOnDevicePreference;
(function (CredentialOnDevicePreference) {
    CredentialOnDevicePreference["REQUIRED"] = "REQUIRED";
    CredentialOnDevicePreference["PREFERRED"] = "PREFERRED";
    CredentialOnDevicePreference["DISCOURAGED"] = "DISCOURAGED";
})(CredentialOnDevicePreference = exports.CredentialOnDevicePreference || (exports.CredentialOnDevicePreference = {}));
class CredentialOnDevice {
    static toLowerCaseEnum(param) {
        if (param === "REQUIRED") {
            return "required";
        }
        else if (param === "PREFERRED") {
            return "preferred";
        }
        else {
            return "discouraged";
        }
    }
}
exports.CredentialOnDevice = CredentialOnDevice;
//# sourceMappingURL=CredentialOnDevice.js.map